class ContentSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector("[data-track]");
    this.action_buttons = this.querySelectorAll("button[data-track-action]");
    this.items_to_observe = [
      this.track.firstElementChild,
      this.track.lastElementChild,
    ];
    this.track_offset = this.track.firstElementChild.offsetWidth;
    this.offset = 0;
  }

  connectedCallback() {
    this.items_to_observe.forEach((item, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.action_buttons[index].disabled = true;
              this.offset = this.track_offset - 16
            } else {
              this.action_buttons[index].disabled = false;
              this.offset = this.track_offset + 16
            }
          });
        },
        {
          root: this.track,
          threshold: 0.5,
        },
      );

      observer.observe(item);
    });
    this.action_buttons.forEach((button) => {
      button.addEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    const { trackAction } = event.target.dataset;
    switch (trackAction) {
      case "prev":
        this.track.scrollBy({ left: -this.offset, behavior: "smooth" });
        break;
      case "next":
        this.track.scrollBy({ left: this.offset, behavior: "smooth" });
        break;
    }
  }
}

customElements.define("content-slider", ContentSlider);
